module.exports = __webpack_public_path__ + "static/img/nothing.0a0fc0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nothing.png
// module id = dA7N
// module chunks = 1